"use client"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Paper,
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"

const ProductDetailsDialog = ({ open, onClose, products }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          background: "linear-gradient(135deg, #1e3a8a 0%, #0055cc 100%)",
          color: "white",
          fontWeight: "bold",
        }}
      >
        Détails du produit
        <IconButton onClick={onClose} sx={{ color: "white" }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <TableContainer
          component={Paper}
          sx={{
            borderRadius: 2,
            border: "1px solid #e0e7ff",
            boxShadow: "0 4px 12px rgba(30, 58, 138, 0.08)",
          }}
        >
          <Table>
            <TableHead>
              <TableRow
                sx={{
                  background: "linear-gradient(135deg, #f0f4f8 0%, #e8ecf5 100%)",
                }}
              >
                <TableCell sx={{ fontWeight: "bold", color: "#1e3a8a" }}>Nom</TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#1e3a8a" }}>Catégorie</TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#1e3a8a" }}>Prix d'achat(Fbu)</TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#1e3a8a" }}>Prix de vente(Fbu)</TableCell>
                <TableCell align="right" sx={{ fontWeight: "bold", color: "#1e3a8a" }}>
                  Bénéfice (Fbu)
                </TableCell>
                <TableCell align="right" sx={{ fontWeight: "bold", color: "#1e3a8a" }}>
                  Quantité
                </TableCell>
                <TableCell align="right" sx={{ fontWeight: "bold", color: "#1e3a8a" }}>
                  T.Bénéfice (Fbu)
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {products?.map((product, index) => (
                <TableRow
                  key={index}
                  sx={{
                    "&:hover": {
                      backgroundColor: "#f3f6fb",
                    },
                  }}
                >
                  <TableCell>{product.name}</TableCell>
                  <TableCell>{product.category}</TableCell>
                  <TableCell>{product.price_achat?.toLocaleString()}</TableCell>
                  <TableCell>{product.prix_de_vente?.toLocaleString()}</TableCell>
                  <TableCell align="right">{(product.prix_de_vente - product.price_achat).toLocaleString()}</TableCell>
                  <TableCell align="right">{product.quantity}</TableCell>
                  <TableCell align="right">
                    {((product.prix_de_vente - product.price_achat) * product.quantity).toLocaleString()}
                  </TableCell>
                </TableRow>
              ))}
              <TableRow
                sx={{
                  background: "linear-gradient(135deg, #f0f4f8 0%, #e8ecf5 100%)",
                  fontWeight: "bold",
                }}
              >
                <TableCell colSpan={6} align="right" sx={{ fontWeight: "bold", color: "#1e3a8a" }}>
                  Total Bénéfice (Fbu)
                </TableCell>
                <TableCell align="right" sx={{ fontWeight: "bold", color: "#1e3a8a" }}>
                  {products
                    ?.reduce(
                      (total, product) => total + (product.prix_de_vente - product.price_achat) * product.quantity,
                      0,
                    )
                    .toLocaleString()}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
    </Dialog>
  )
}

export default ProductDetailsDialog
